import { get } from 'lodash/fp';
import axios from './axios';

export default (jobId, opts = {}) =>
  axios.post(`/jobs/${jobId}/create-configuration`, opts, {
    cancellationKey: jobId,
  })
    .then(get('data'));
